import React, { useMemo } from 'react';

import { View } from 'react-native';

import BlockRenderer from 'components/sanity-block-renderer';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { t } from 'state/intl/translations';
import { useProductWizardContext } from 'state/product-wizard-v2';

import { ProductInformationContainer, ProductInformationTitle } from './styled';

export const ProductInformation: React.FC = () => {
  const { selectedProduct } = useProductWizardContext();
  const isDesktop = useIsDesktopBreakpoint();
  const productInformationTextProps = useMemo(
    () => ({ fontSize: isDesktop ? ('sm' as const) : ('xs' as const) }),
    [isDesktop]
  );

  if (!selectedProduct.description?.localeRaw) {
    return null;
  }

  const title = t('productInformation');

  // Create a unique identifier for the description
  const contentKey = `${selectedProduct._id}-${selectedProduct.description.localeRaw[0]?._key}`;

  return (
    <ProductInformationContainer testID="product-information-container">
      <ProductInformationTitle accessibilityRole="header" accessibilityLevel={3}>
        {title}
      </ProductInformationTitle>
      <View key={contentKey} collapsable={false}>
        <BlockRenderer
          content={selectedProduct.description.localeRaw}
          textProps={productInformationTextProps}
        />
      </View>
    </ProductInformationContainer>
  );
};
